import { render, staticRenderFns } from "./DetalleActivarCurso.vue?vue&type=template&id=81528aee&"
import script from "./DetalleActivarCurso.vue?vue&type=script&lang=js&"
export * from "./DetalleActivarCurso.vue?vue&type=script&lang=js&"
import style0 from "./DetalleActivarCurso.vue?vue&type=style&index=0&id=81528aee&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports